export default __webpack_public_path__ + "static/media/Avoid-being-in-the-dark.c5bed98c.svg";